import React from 'react';
import { useLanguage } from '../../context/LanguageContext';

const testimonials = [
  {
    name: 'Marcus Chen',
    role: 'Day Trader',
    image: 'https://images.unsplash.com/photo-1737575655055-e3967cbefd03?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTF8MHwxfHNlYXJjaHwyfHxwcm9mZXNzaW9uYWwlMjBzdWNjZXNzZnVsJTIwdHJhZGVyJTIwcG9ydHJhaXR8ZW58MHx8fHwxNzc1MzI4OTQyfDA&ixlib=rb-4.1.0&q=85',
    quote: 'The Futures Pro course completely transformed my trading. I went from inconsistent results to consistent profitability within 3 months.',
    profit: '+127% ROI'
  },
  {
    name: 'Sarah Mitchell',
    role: 'Portfolio Manager',
    image: 'https://images.unsplash.com/photo-1733348137468-90b917d2ebf1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTF8MHwxfHNlYXJjaHwxfHxwcm9mZXNzaW9uYWwlMjBzdWNjZXNzZnVsJTIwdHJhZGVyJTIwcG9ydHJhaXR8ZW58MHx8fHwxNzc1MzI4OTQyfDA&ixlib=rb-4.1.0&q=85',
    quote: 'Options Mastery gave me the edge I needed. The strategies taught here are practical and immediately applicable.',
    profit: '+89% ROI'
  }
];

export function TestimonialsSection() {
  const { t } = useLanguage();

  return (
    <section id="testimonials" className="py-24 bg-[#141417]">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-white mb-4" style={{ fontFamily: 'Chivo, sans-serif' }}>
            {t('landing.testimonialTitle')}
          </h2>
          <p className="text-[#A1A1AA] text-lg">{t('landing.testimonialSubtitle')}</p>
        </div>
        
        <div className="grid md:grid-cols-2 gap-8">
          {testimonials.map((testimonial) => (
            <div 
              key={testimonial.name}
              className="bg-[#09090B] border border-[#27272A] rounded-md p-8 animate-fade-in-up"
              data-testid={`testimonial-${testimonial.name.toLowerCase().replace(' ', '-')}`}
            >
              <div className="flex items-center gap-4 mb-6">
                <img src={testimonial.image} alt={testimonial.name} className="w-16 h-16 rounded-full object-cover" />
                <div>
                  <h4 className="text-white font-bold">{testimonial.name}</h4>
                  <p className="text-[#71717A] text-sm">{testimonial.role}</p>
                </div>
                <div className="ml-auto">
                  <span className="text-[#00FF66] font-mono font-bold">{testimonial.profit}</span>
                </div>
              </div>
              <p className="text-[#A1A1AA] italic">"{testimonial.quote}"</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
